import React, { Fragment } from 'react';
import classNames from 'classnames';
import './index.less';

export default ({ options }) => {
  return (
    <ul className="merchants-time-line-new">
      {options
        .filter((item) => item.show())
        .map((item, index) => (
          <Fragment key={index}>
            {index !== 0 ? <li className="merchants-time-line-divide-wrapper-new">{item.divide}</li> : null}
            <li
              className={classNames('merchants-time-line-item-new', { 'merchants-time-line-light-new': item.isLight })}
              key={item.title}
              style={item.cardStyle ? item.cardStyle : null}
            >
              <div>
                <p className="merchants-time-line-item-title-new">{item.title}</p>
                <div className="merchants-time-line-item-body-new">{item.body}</div>
                <div className="merchants-time-line-item-footer-new">{item.footer}</div>
              </div>
              <div className="merchants-time-line-no-new">{index + 1}</div>
            </li>
          </Fragment>
        ))}
    </ul>
  );
};
